var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 24,
    height: 24,
    transform: "translate(1133 -115)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u06A9\\u0627\\u0631\\u062A_\\u062A\\u062E\\u0641\\u06CC\\u0641_\\u0648_\\u0635\\u0631\\u0627\\u0641\\u06CC",
    "data-name": "\\u06A9\\u0627\\u0631\\u062A \\u062A\\u062E\\u0641\\u06CC\\u0641 \\u0648 \\u0635\\u0631\\u0627\\u0641\\u06CC",
    transform: "translate(-1133 115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8920",
    "data-name": "Group 8920",
    transform: "translate(1138.25 -112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-c",
    d: "M15.449,8.737l4.06,4.119a1.242,1.242,0,0,1,0,1.757l-4.06,4.135a1.224,1.224,0,0,1-1.749,0,1.268,1.268,0,0,1,0-1.773L15.652,15H6.867a1.255,1.255,0,0,1,0-2.511h8.785L13.7,10.51a1.268,1.268,0,0,1,0-1.773A1.228,1.228,0,0,1,15.449,8.737Z",
    transform: "translate(-5.624 -8.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-c-2",
    "data-name": "arrow-right-c",
    d: "M10.049,8.737l-4.06,4.119a1.242,1.242,0,0,0,0,1.757l4.06,4.135a1.224,1.224,0,0,0,1.749,0,1.268,1.268,0,0,0,0-1.773L9.846,15h8.785a1.255,1.255,0,0,0,0-2.511H9.85L11.8,10.51a1.268,1.268,0,0,0,0-1.773A1.228,1.228,0,0,0,10.049,8.737Z",
    transform: "translate(-5.624 -1.116)",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.805caa16c79bb46eca145669de781f25.svg";
export { ForwardRef as ReactComponent };